import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@dental-ui/shared/i18n';

export interface MenuItem {
  label: string;
  route: string;
  icon: string;
}

@Component({
  selector: 'lib-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslatePipe],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent {
  @Input() menuItems: MenuItem[] = [];
  @Input() isCollapsed = false;
  @Output() menuItemClick = new EventEmitter<MenuItem>();
}

